import { styled, Tab } from '@mui/material';

export const StyledTabs = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  padding: theme.spacing(2, 0),
  marginRight: theme.spacing(15),
  minWidth: 'auto',
  maxWidth: 'auto',
  minHeight: 'none',
  height: '100%',
  color: theme.palette.text.primary,
}));

export const StyledTabPanel = styled('div', {
  shouldForwardProp: (prop) => prop !== 'shouldShow',
})<{ shouldShow: boolean }>(({ theme, shouldShow }) => ({
  flex: '1 0 auto',
  display: shouldShow ? 'flex' : 'none',
  paddingBottom: theme.spacing(15),
}));
